
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../../withItemCache/WithItemCache';
import { Action } from '../../action/Action';
import { selectItems } from '../../../operations/selectItems';
import { connectToItemsScope } from '../../decorators/connectToItemsScope';
import { withSelectedItems } from '../../decorators/selectors';
import { Facet } from '../../../models/Facet';

const noSelectionKey = new Facet('noSelection').id;

export class ClearSelectionActionBase extends React.PureComponent<{ itemKeys: string[]; itemsScopeItemKey: string }> {
  public render(): JSX.Element {
    const {
      itemKeys,
      itemsScopeItemKey
    } = this.props;

    return (
      <WithItemCache>
        { ({ dispatch }: IItemCacheStateProps) => {
          const onExecute = async () => {
            dispatch(selectItems({
              selectedItemKeys: [],
              currentSelectionKey: noSelectionKey,
              itemsScopeItemKey: itemsScopeItemKey
            }));
          };

          return (
            <Action isAvailable={ itemKeys.length > 0 } onExecute={ onExecute } />
          );
        } }
      </WithItemCache>
    );
  }
}

export const ClearSelectionAction = connectToItemsScope()(withSelectedItems()(ClearSelectionActionBase));
